import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function Privacy() {
  return (
    <div className="container-x pt-32 pb-24 md:pt-40 max-w-3xl" data-testid="privacy-page">
      <SEO
        title="Privacy & Cookie Policy | Ri.Sco. s.r.l."
        description="Informativa privacy e cookie policy di Ri.Sco. s.r.l. Napoli, conforme al GDPR. Modalità di trattamento dei dati raccolti tramite il sito e i moduli di contatto."
        path="/privacy"
      />
      <div className="overline mb-6">Documento</div>
      <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl tracking-tighter text-risco-ink leading-[0.95]">
        <span className="font-display italic">Privacy</span> & Cookie Policy
      </h1>
      <p className="text-stone-600 mt-6 text-lg">Informativa ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 (GDPR), del D.Lgs. 196/2003 e s.m.i., e del Provvedimento del Garante Privacy 231/2021 in materia di cookie.</p>

      <div className="mt-12 space-y-10 text-stone-700 leading-relaxed">

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">1. Titolare del trattamento</h2>
          <p><strong>Ri.Sco. s.r.l.</strong>, con sede legale in Via Martiri di Pietrarsa 20, 80046 San Giorgio a Cremano (NA) — P.IVA 09679001215 — è il Titolare del trattamento dei dati personali raccolti attraverso il sito riscocostruzioni.it.</p>
          <p className="mt-2">Per esercitare i tuoi diritti o ricevere informazioni scrivi a <a href="mailto:info@riscocostruzioni.it" className="text-risco-accent">info@riscocostruzioni.it</a>.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">2. Categorie di dati raccolti</h2>
          <p>Attraverso i form del sito raccogliamo unicamente i dati che l'utente sceglie di fornire volontariamente:</p>
          <ul className="list-disc pl-6 mt-3 space-y-2">
            <li><strong>Analizzatore di Progetto AI:</strong> nome e cognome, email, telefono (facoltativo), parametri del progetto (tipo di intervento, tipologia di immobile, superficie, stato attuale, città o zona, tempistica desiderata, eventuali note libere).</li>
            <li><strong>Modulo "Proponi il tuo affare":</strong> nome e cognome, email, tipologia di proposta immobiliare, tipo di accordo desiderato, indirizzo o zona dell'immobile, superficie, stato e note descrittive, eventuali foto e documenti caricati.</li>
            <li><strong>Form contatti:</strong> nome e cognome, email, contenuto del messaggio.</li>
            <li><strong>Dati di navigazione:</strong> raccolti in forma aggregata e non identificativa (indirizzo IP anonimizzato, tipo di browser, pagine visitate) per finalità di sicurezza e statistica.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">3. Finalità del trattamento</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Elaborazione di un'analisi qualitativa del progetto tramite modello AI (Claude Sonnet 4.5) e successivo contatto commerciale per proporre un sopralluogo gratuito. L'analisi generata non contiene importi e non costituisce preventivo né impegno contrattuale.</li>
            <li>Valutazione delle proposte immobiliari e successivo contatto per approfondimenti.</li>
            <li>Risposta alle richieste inviate tramite il form contatti.</li>
            <li>Adempimenti fiscali e contabili nel caso di rapporti contrattuali.</li>
            <li>Sicurezza del sito, prevenzione di abusi e conformità agli obblighi di legge.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">4. Base giuridica</h2>
          <p>Il trattamento si fonda sull'<strong>esecuzione di misure precontrattuali richieste dall'interessato</strong> (art. 6.1.b GDPR), sul <strong>consenso libero e informato</strong> dell'interessato quando espressamente richiesto (art. 6.1.a GDPR) e sull'<strong>obbligo legale</strong> a cui è soggetto il Titolare (art. 6.1.c GDPR).</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">5. Modalità e periodo di conservazione</h2>
          <p>I dati sono trattati con strumenti elettronici, con misure tecniche e organizzative adeguate a garantirne la sicurezza. I dati raccolti tramite i form sono conservati per il tempo strettamente necessario a rispondere alle richieste e, in ogni caso, non oltre <strong>24 mesi</strong> dall'ultimo contatto, salvo obblighi di legge diversi o esigenze di tutela in sede giudiziaria.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">6. Destinatari dei dati</h2>
          <p>I dati non sono diffusi né ceduti a terzi per finalità di marketing. Possono essere comunicati a:</p>
          <ul className="list-disc pl-6 mt-3 space-y-2">
            <li>Personale interno di Ri.Sco. s.r.l. autorizzato al trattamento.</li>
            <li>Fornitori di servizi tecnici (hosting, servizio email transazionale, cloud storage) designati come Responsabili del trattamento ex art. 28 GDPR.</li>
            <li>Autorità pubbliche, laddove richiesto da un obbligo di legge.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">7. Trasferimento extra-UE</h2>
          <p>Alcuni fornitori tecnici (ad es. hosting, servizi AI) potrebbero trattare i dati anche al di fuori dell'Unione Europea. In tal caso il trasferimento avviene sulla base di <strong>Clausole Contrattuali Standard</strong> approvate dalla Commissione Europea o di altre garanzie adeguate previste dagli artt. 44-49 GDPR.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">8. Diritti dell'interessato</h2>
          <p>In ogni momento puoi esercitare i seguenti diritti:</p>
          <ul className="list-disc pl-6 mt-3 space-y-2">
            <li>Accesso ai tuoi dati personali (art. 15 GDPR).</li>
            <li>Rettifica dei dati inesatti (art. 16).</li>
            <li>Cancellazione ("diritto all'oblio") (art. 17).</li>
            <li>Limitazione del trattamento (art. 18).</li>
            <li>Portabilità dei dati (art. 20).</li>
            <li>Opposizione al trattamento (art. 21).</li>
            <li>Revoca del consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento precedente.</li>
            <li>Proporre reclamo al Garante per la protezione dei dati personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer" className="text-risco-accent">www.garanteprivacy.it</a>).</li>
          </ul>
          <p className="mt-3">Per esercitare i tuoi diritti scrivi a <a href="mailto:info@riscocostruzioni.it" className="text-risco-accent">info@riscocostruzioni.it</a>. Riceverai riscontro entro 30 giorni.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">9. Cookie Policy</h2>
          <p>Il sito utilizza cookie per garantirne il corretto funzionamento e, previo consenso, per finalità analitiche o di profilazione. Le categorie di cookie utilizzate sono:</p>

          <div className="mt-4 space-y-4">
            <div className="risco-card p-5">
              <div className="text-xs uppercase tracking-widest text-risco-accent font-semibold">Cookie tecnici</div>
              <div className="mt-1 text-risco-ink font-medium">Necessari · consenso non richiesto</div>
              <p className="text-sm mt-2">Assicurano il funzionamento del sito, la navigazione, il mantenimento della sessione e la sicurezza. Non identificano l'utente.</p>
            </div>
            <div className="risco-card p-5">
              <div className="text-xs uppercase tracking-widest text-risco-accent font-semibold">Cookie di preferenza</div>
              <div className="mt-1 text-risco-ink font-medium">Memorizzano le scelte dell'utente (es. banner cookie)</div>
              <p className="text-sm mt-2">Consentono di ricordare le preferenze espresse per non riproporre il banner ad ogni visita. Vengono attivati solo dopo la scelta dell'utente.</p>
            </div>
            <div className="risco-card p-5">
              <div className="text-xs uppercase tracking-widest text-risco-accent font-semibold">Cookie analitici e di profilazione</div>
              <div className="mt-1 text-risco-ink font-medium">Solo previo consenso esplicito</div>
              <p className="text-sm mt-2">Vengono attivati solo dopo il consenso tramite banner. Consentono di misurare l'uso del sito in forma aggregata. È possibile ritirare il consenso in qualsiasi momento eliminando i cookie dal browser o riaprendo il banner.</p>
              <p className="text-sm mt-3">
                <strong>Google Analytics 4</strong> (fornitore: Google Ireland Ltd. — Measurement ID <code className="text-xs">G-DQYHC97PMR</code>).
                Finalità: statistica / analisi aggregata del traffico e delle interazioni.
                Base giuridica: consenso dell'interessato (art. 6.1.a GDPR).
                IP anonimizzato attivo. Trasferimento dati anche extra-UE con Clausole Contrattuali Standard.
                È adottato il <strong>Google Consent Mode v2</strong>: fino al consenso lo storage analitico è impostato su <em>denied</em> e nessun cookie di tracciamento viene scritto.
                Puoi opporti in ogni momento tramite <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer" className="text-risco-accent">tools.google.com/dlpage/gaoptout</a>.
              </p>
            </div>
          </div>

          <p className="mt-4 text-sm">Puoi modificare le tue preferenze in qualsiasi momento cancellando i cookie dal tuo browser. Per informazioni: <a href="https://www.garanteprivacy.it/cookie" target="_blank" rel="noreferrer" className="text-risco-accent">garanteprivacy.it/cookie</a>.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-risco-ink mb-3">10. Aggiornamenti dell'informativa</h2>
          <p>Ri.Sco. s.r.l. si riserva il diritto di aggiornare la presente informativa per adeguarla a modifiche normative o a nuove funzionalità del sito. Le versioni aggiornate saranno pubblicate su questa pagina con indicazione della data dell'ultimo aggiornamento.</p>
          <p className="mt-3 text-sm text-stone-500">Ultimo aggiornamento: luglio 2026.</p>
        </section>

      </div>

      <Link to="/" className="inline-flex mt-12 text-risco-accent hover:text-risco-accent-dark" data-testid="privacy-back-home">← Torna alla home</Link>
    </div>
  );
}
